import logo from "@/assets/logo.png";
import { useSeason } from "@/components/seasonal/SeasonalThemeProvider";

const SiteFooter = () => {
  const { season } = useSeason();
  return (
    <footer className="bg-[hsl(140_12%_12%)] text-[hsl(40_30%_92%)] pt-12 pb-0 overflow-hidden">
      {season && season.footer_note && (
        <>
          <div className="h-[3px] w-full bg-season-ribbon" aria-hidden />
          <div className="container mx-auto px-6 pt-6 pb-2 text-xs text-[hsl(40_15%_70%)] flex items-center gap-2">
            {season.badge_emoji && <span aria-hidden>{season.badge_emoji}</span>}
            <span>{season.footer_note}</span>
          </div>
        </>
      )}
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-10">
          <div>
            <h4 className="font-display font-bold text-lg mb-4 flex items-center gap-2">
              <img src={logo} alt="emrkt logo" className="h-10 w-10" />
              <span>emrkt<span className="text-primary">.co</span></span>
            </h4>
            <p className="text-sm text-[hsl(40_15%_70%)] leading-relaxed">
              Data-driven advocacy connecting Alabama communities with the state policies that shape their futures.
            </p>
          </div>
          {[
            { title: "Platform", links: [
              { label: "Ideas", href: "/ideas" },
              { label: "Opportunities", href: "/opportunities" },
              { label: "Research & Insights", href: "/insights" },
              { label: "Events", href: "/events" },
            ] },
            { title: "Network", links: [
              { label: "Partners", href: "/partners" },
              { label: "Affiliates", href: "/affiliates" },
              { label: "Apply to Join", href: "/affiliates/apply" },
            ] },
            { title: "Company", links: [
              { label: "About", href: "/about" },
              { label: "Our Services", href: "/services" },
              { label: "Pricing", href: "/pricing" },
              { label: "Contact", href: "#" },
              { label: "Status", href: "/status" },
            ] },
            { title: "Legal", links: [
              { label: "Privacy Policy", href: "/privacy" },
              { label: "Terms of Service", href: "/terms" },
              { label: "Cookie Policy", href: "/cookies" },
              { label: "Acceptable Use", href: "/acceptable-use" },
              { label: "Records Retention", href: "/retention" },
              { label: "DPA", href: "/dpa" },
              { label: "Security", href: "/security" },
            ] },
          ].map((col) => (
            <div key={col.title}>
              <h5 className="font-display font-semibold text-sm mb-4 text-[hsl(40_30%_92%)]">{col.title}</h5>
              <ul className="space-y-2">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-[hsl(40_15%_70%)] hover:text-primary transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="border-t border-white/10 pt-6 text-center text-xs text-[hsl(40_15%_60%)]">
          © 2026 emrkt.co. All rights reserved.
        </div>
      </div>

      {/* Decorative giant outlined wordmark */}
      <div aria-hidden className="mt-8 -mb-4 select-none pointer-events-none">
        <div className="font-display font-bold leading-none tracking-tight text-center whitespace-nowrap text-[22vw]"
          style={{
            WebkitTextStroke: '1px hsl(40 20% 70% / 0.35)',
            color: 'transparent',
          }}
        >
          emerging market
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
